import ContentfulTag from "models/data/contentful/ContentfulTag";

class ContentfulToApiTag {
  static map = (contentfulTag) => {
    return {
      id: ContentfulTag.id(contentfulTag),
      name: ContentfulTag.tagName(contentfulTag),
    };
  };
}

export default ContentfulToApiTag;
